export { SearchResultsContentDS } from './search-results-content-ds'
export type { SearchResultsContentDSProps } from './search-results-content-ds'
